import {
  COLLECTION_LIST_GET,
  COLLECTION_LIST_GET_SUCCESS,
  COLLECTION_LIST_GET_ERROR,
  CREATE_COLLECTION,
  CREATE_COLLECTION_SUCCESS,
  CREATE_COLLECTION_ERROR,
  GET_COLLECTION,
  GET_COLLECTION_SUCCESS,
  GET_COLLECTION_ERROR,
  SET_PAGE_VIEW,
  DELETE_COLLECTION,
  DELETE_COLLECTION_SUCCESS,
  DELETE_COLLECTION_ERROR,
  GET_COLLECTION_COURSE_LIST,
  GET_COLLECTION_COURSE_LIST_SUCCESS,
  GET_COLLECTION_COURSE_LIST_ERROR,
  COURSE_DELETE,
  COURSE_DELETE_SUCCESS,
  COURSE_DELETE_ERROR,
  EDIT_COURSE_COLLECTION_INDEX,
  EDIT_COURSE_COLLECTION_INDEX_SUCCESS,
  EDIT_COURSE_COLLECTION_INDEX_ERROR,
  COURSE_CLONE,
  COURSE_CLONE_SUCCESS,
  COURSE_CLONE_ERROR,
  GET_COLLECTION_SETTINGS,
  GET_COLLECTION_SETTINGS_SUCCESS,
  GET_COLLECTION_SETTINGS_ERROR,
  PATCH_COURSE_COLLECTION,
  PATCH_COURSE_COLLECTION_SUCCESS,
  PATCH_COURSE_COLLECTION_ERROR,
  PATCH_COLLECTION_SETTINGS,
  PATCH_COLLECTION_SETTINGS_SUCCESS,
  PATCH_COLLECTION_SETTINGS_ERROR,
  GET_COLLECTION_LANDING_PAGE,
  GET_COLLECTION_LANDING_PAGE_SUCCESS,
  GET_COLLECTION_LANDING_PAGE_ERROR,
  PATCH_COLLECTION_LANDING_PAGE,
  PATCH_COLLECTION_LANDING_PAGE_SUCCESS,
  PATCH_COLLECTION_LANDING_PAGE_ERROR,
} from './type'

export const getCollectionList = (query, callback) => {
  return {
    type: COLLECTION_LIST_GET,
    payload: { query, callback },
  }
}

export const getCollectionListSuccess = data => {
  return {
    type: COLLECTION_LIST_GET_SUCCESS,
    payload: data,
  }
}

export const getCollectionListError = () => {
  return {
    type: COLLECTION_LIST_GET_ERROR,
  }
}

/**
 *
 * @param {*} entity
 * @param {*} callback
 */
export const createCollectionAction = (entity, callback) => {
  return {
    type: CREATE_COLLECTION,
    payload: { entity, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const createCollectionSuccess = response => {
  return {
    type: CREATE_COLLECTION_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const createCollectionError = () => {
  return {
    type: CREATE_COLLECTION_ERROR,
  }
}

export const getCollection = (id, callback) => {
  return {
    type: GET_COLLECTION,
    payload: { id, callback },
  }
}

export const getCollectionSuccess = response => {
  return {
    type: GET_COLLECTION_SUCCESS,
    payload: response,
  }
}

export const getCollectionError = () => {
  return {
    type: GET_COLLECTION_ERROR,
  }
}

export const setPageView = pageView => {
  return {
    type: SET_PAGE_VIEW,
    payload: pageView,
  }
}

export const deleteCollection = (id, callback) => {
  return {
    type: DELETE_COLLECTION,
    payload: { id, callback },
  }
}

export const deleteCollectionSuccess = response => {
  return {
    type: DELETE_COLLECTION_SUCCESS,
    payload: response,
  }
}

export const deleteCollectionError = () => {
  return {
    type: DELETE_COLLECTION_ERROR,
  }
}

export const getCollectionCourseList = (id, callback) => {
  return {
    type: GET_COLLECTION_COURSE_LIST,
    payload: { id, callback },
  }
}

export const getCollectionCourseListSuccess = response => {
  return {
    type: GET_COLLECTION_COURSE_LIST_SUCCESS,
    payload: response,
  }
}

export const getCollectionCourseListError = () => {
  return {
    type: GET_COLLECTION_COURSE_LIST_ERROR,
  }
}

/**
 *
 * @param {*} entity
 * @param {*} callback
 */
export const courseDeleteAction = (id, callback) => {
  return {
    type: COURSE_DELETE,
    payload: { id, callback },
  }
}

/**
 *
 * @param {*} entity
 */
export const courseDeleteSuccess = response => {
  return {
    type: COURSE_DELETE_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const courseDeleteError = () => {
  return {
    type: COURSE_DELETE_ERROR,
  }
}

/**
 *
 * @param {*} entity
 */
export const editCourseCollectionIndexAction = (entity, callback) => {
  return {
    type: EDIT_COURSE_COLLECTION_INDEX,
    payload: { entity, callback },
  }
}

/**
 *
 * @param {*} entity
 */
export const editCourseCollectionIndexSuccess = entity => {
  return {
    type: EDIT_COURSE_COLLECTION_INDEX_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const editCourseCollectionIndexError = () => {
  return {
    type: EDIT_COURSE_COLLECTION_INDEX_ERROR,
  }
}

/**
 *
 * @param {*} code
 * @param {*} callback
 */
export const courseCloneAction = (code, callback, history) => {
  return {
    type: COURSE_CLONE,
    payload: { code, callback, history },
  }
}

/**
 *
 * @param {*} entity
 */
export const courseCloneSuccess = entity => {
  return {
    type: COURSE_CLONE_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const courseCloneError = () => {
  return {
    type: COURSE_CLONE_ERROR,
  }
}

/**
 *
 * @param {*} id
 * @param {*} callback
 */
export const getCollectionSettingsAction = (id, callback) => {
  return {
    type: GET_COLLECTION_SETTINGS,
    payload: { id, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const getCollectionSettingsSuccess = response => {
  return {
    type: GET_COLLECTION_SETTINGS_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const getCollectionSettingsError = () => {
  return {
    type: GET_COLLECTION_SETTINGS_ERROR,
  }
}

/**
 *
 * @param {*} content
 * @param {*} callback
 */
export const patchCourseCollectionAction = (content, callback) => {
  return {
    type: PATCH_COURSE_COLLECTION,
    payload: { content, callback },
  }
}

/**
 *
 * @param {*} content
 */
export const patchCourseCollectionSuccess = content => {
  return {
    type: PATCH_COURSE_COLLECTION_SUCCESS,
    payload: { content },
  }
}

export const patchCourseCollectionError = () => {
  return {
    type: PATCH_COURSE_COLLECTION_ERROR,
  }
}

/**
 *
 * @param {*} content
 * @param {*} callback
 */
export const patchCollectionSettingsAction = (content, callback) => {
  return {
    type: PATCH_COLLECTION_SETTINGS,
    payload: { content, callback },
  }
}

/**
 *
 * @param {*} content
 */
export const patchCollectionSettingsSuccess = content => {
  return {
    type: PATCH_COLLECTION_SETTINGS_SUCCESS,
    payload: { content },
  }
}

/**
 *
 */
export const patchCollectionSettingsError = () => {
  return {
    type: PATCH_COLLECTION_SETTINGS_ERROR,
  }
}

/**
 *
 */
export const getCollectionLandingPageAction = (id, callback) => {
  return {
    type: GET_COLLECTION_LANDING_PAGE,
    payload: { id, callback },
  }
}

export const getCollectionLandingPageSuccess = response => {
  return {
    type: GET_COLLECTION_LANDING_PAGE_SUCCESS,
    payload: { response },
  }
}

export const getCollectionLandingPageError = () => {
  return {
    type: GET_COLLECTION_LANDING_PAGE_ERROR,
  }
}

export const patchCollectionLandingPageAction = (id, data, callback) => {
  return {
    type: PATCH_COLLECTION_LANDING_PAGE,
    payload: { id, data, callback },
  }
}

export const patchCollectionLandingPageSuccess = response => {
  return {
    type: PATCH_COLLECTION_LANDING_PAGE_SUCCESS,
    payload: { response },
  }
}

export const patchCollectionLandingPageError = () => {
  return {
    type: PATCH_COLLECTION_LANDING_PAGE_ERROR,
  }
}
